export default __webpack_public_path__ + "static/bedroom-69570_1280-1abcd2262521760a4661b8b53f8ced26.png";